import consumer from './consumer';

document.addEventListener('DOMContentLoaded', () => {
  if (!$('#subscription-intention-id').length) {
    return;
  }

  consumer.subscriptions.create(
    {
      channel: 'SubscriptionIntentionChannel',
      subscription_intention_id: $('#subscription-intention-id').data('id'),
    },
    {
      received(data) {
        try {
          if (data.status === 'success') {
            setTimeout(() => {
              window.location.href = data.next_step_path;
            }, 5000);
          } else if (data.status === 'failure') {
            setTimeout(() => {
              $('#subscriptionStep1').addClass('d-none');
              $('#subscriptionStep1Failure').removeClass('d-none');
            }, 5000);
          } else {
            setTimeout(() => {
              $('#subscriptionStep1').addClass('d-none');
              $('#subscriptionStep1Error').removeClass('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            $('#subscriptionStep1').addClass('d-none');
            $('#subscriptionStep1Error').removeClass('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          $('#subscriptionStep1').addClass('d-none');
          $('#subscriptionStep1Error').removeClass('d-none');
        }, 5000);
        this.uninstall();
      },
    },
  );
});
